<script setup lang="ts">
import type { SidebarItem } from '~/data/studentNavs'

const props = defineProps({
  link: { type: Object as PropType<SidebarItem>, required: true },
  active: { type: String, required: true }
})

const checkActive = (link: SidebarItem) => {
  if (link.active) return link.active.includes(props.active)
  return false
}
</script>

<template>
  <div :class="`link ${checkActive(link) ? 'link-active' : ''}`">
    <NuxtLink :to="link.link">{{ link.title }} </NuxtLink>
  </div>
</template>

<style scoped lang="scss">
.link {
  display: flex;
  align-items: center;
  height: 100%;
  border: 2px solid transparent;
  padding: 0 10px;
  position: relative;

  a {
    color: var(--black);
    font-size: 0.9rem;
    border-radius: 7px;
    padding: 20px 10px;
  }
}

.link::before {
  content: '';
  position: absolute;
  height: 3px;
  bottom: -3px;
  left: 0;
  right: 0;
}

.link-active {
  a {
    color: var(--black);
    font-weight: 500;
  }
}

.link-active::before {
  background: var(--purple);
}

@media (max-width: 1250px) {
  .link {
    a {
      padding: 20px 8px;
    }
  }
}

@media (hover: hover) {
  .link {
    a:hover {
      color: var(--textM2);
    }
  }

  .link-active {
    a:hover {
      color: var(--black);
    }
  }
}
</style>
